<script setup lang="ts">
import findSm from "~/assets/icons/find/find-sm.svg"

const { searchButton } = useGlobals()
</script>

<template>
  <nav-pill class="search-pill-container">
    <nav-pill-button :class="[searchButton]" class="search-pill-button">
      <findSm class="w-4.5" />
      <div>Search</div>
    </nav-pill-button>
  </nav-pill>
</template>

<style lang="sass" scoped>
@import '~/assets/styles/generated/variables.sass'

.search-pill-container
  @apply overflow-hidden p-[#{$pill-m-button}]

.search-pill-button
  @apply flex-none pl-1 pr-1.75 text-[#{$pill-path-t-focused}] flex items-center
</style>
